import LinkLookup from 'components/LinkLookup';
import UsersStats from 'components/UserSidebar/UsersStats';
import pluralize from 'pluralize';
import React from 'react';
import { useParams } from 'react-router-dom';
import { getImportUsersListFileName } from 'selectors/import';
import { getImportErrors, getUsersGeneralCounts } from 'selectors/userPermissionsPage';
import { useSelector } from 'store';

const ImportReviewSideSection: React.FC = () => {
  const { cohortId } = useParams<{ cohortId: string }>();
  const importErrors = useSelector(getImportErrors);

  const fileName = useSelector(getImportUsersListFileName);

  const { insight, prevent, total } = useSelector(getUsersGeneralCounts);

  return (
    <div className="w-2/5 pl-10 pt-4 h-full flex flex-col gap-4 text-body bg-white">
      <div className="flex flex-col gap-4">
        <span className="text-heading-3">User List</span>
        <div className="pl-8 flex flex-col gap-4">
          <span>{fileName}</span>
          <div className="flex flex-col gap-1">
            <p>
              Total users:{' '}
              <b>
                {total} {pluralize('user', total)}
              </b>
            </p>
            <p>
              Prevent:{' '}
              <b>
                {prevent} {pluralize('seats', prevent)}
              </b>
            </p>
            <p>
              Insight{' '}
              <b>
                {insight} {pluralize('seats', insight)}
              </b>
            </p>
          </div>
          {importErrors.length > 0 && (
            <span className="text-litlingo-alert">Address {importErrors.length} import issues</span>
          )}
          <LinkLookup
            type="button"
            routeName="import-users-permissions"
            routeParams={{ cohortId }}
            className="button button--secondary self-end h-8"
          >
            <span className="font-bold">Go to User Page</span>
          </LinkLookup>
        </div>
      </div>
      <div className="border-b border-litlingo-gray-2" />
      {total !== 0 && (
        <div className="flex flex-col gap-2">
          <span className="text-heading-3">Import Summary</span>
          <UsersStats selectedUsersOnly={false} />
        </div>
      )}
    </div>
  );
};

export default ImportReviewSideSection;
